/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { GridOffset } from "@insite/mobius/GridContainer";
import getColor from "@insite/mobius/utilities/getColor";
import { scheduleReminderModalStyles } from "@monsma/Overrides/Components/ScheduleReminderModal";
import { css } from "styled-components";

scheduleReminderModalStyles.modal = {};

scheduleReminderModalStyles.headlineWraper = {
    css: css`
        margin-bottom: 15px;
        padding-bottom: 10px;
        display: inline-block;
        border-bottom: 1px solid ${getColor("common.ui12")};
        width: 100%;
        line-height: 26px;
    `,
};

scheduleReminderModalStyles.titleText = {
    variant: "h3",
    css: css`
        margin-bottom: 5px;
    `,
};

scheduleReminderModalStyles.hintText = {
    css: css`
        margin-top: 5px;
        font-size: 13px;
    `,
};

scheduleReminderModalStyles.contentContainer = {
    gap: 15,
};

scheduleReminderModalStyles.frequencyRadioGroup = {
    css: css`
        display: inline-block;
        width: 100%;
        flex-direction: row;
        & > div {
            margin-right: 20px;
            display: inline-flex;
        }
    `,
};

scheduleReminderModalStyles.weeklyRadio = {};
scheduleReminderModalStyles.monthlyRadio = {};

scheduleReminderModalStyles.middleRowContainer = { gap: 15 };

scheduleReminderModalStyles.middleRowLeftColumnGridItem = { width: 12 };

scheduleReminderModalStyles.middleRowRightColumnGridItem = { width: 12 };

scheduleReminderModalStyles.leftColumnContainer = { gap: 15 };

scheduleReminderModalStyles.startDateGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        align-items: initial;
    `,
};

scheduleReminderModalStyles.endDateGridItem = {
    width: [12, 12, 6, 6, 6],
    css: css`
        flex-direction: column;
        align-items: initial;
    `,
};

scheduleReminderModalStyles.buttonsContainer = {
    gap: 15,
    css: css`
        & ${GridOffset} {
            justify-content: flex-end;
        }
    `,
};

scheduleReminderModalStyles.startDatePicker = {
    cssOverrides: {
        formInputWrapper: css`
            width: 100%;
        `,
    },
};

scheduleReminderModalStyles.endDatePicker = {
    cssOverrides: {
        formInputWrapper: css`
            width: 100%;
        `,
    },
};
